import pages from '../router/page';
import { Setting, House, Histogram, ShoppingCart, User, Management } from "@element-plus/icons-vue";
export default {
  components: {
    Setting: Setting,
    House: House,
    Histogram: Histogram,
    ShoppingCart: ShoppingCart,
    User: User,
    Management: Management
  },
  props: ['title'],
  setup: function setup() {
    return {
      pages: pages
    };
  }
};